import ConfirmUpdateEncryptionModal from "./ConfirmUpdateEncryption";

const accountModalsComponents = {
  ConfirmUpdateEncryptionModal
}

export default accountModalsComponents;